import { PureComponent } from 'react';
import PropTypes from 'prop-types';

import MapPinNormal from './MapPinNormal';
import MapPinSaved from './MapPinSaved';
import MapPinAdded from './MapPinAdded';
import MapPin from './MapPin';

const pinTypeMap = {
    zonedSchoolEligibility: {
      PinType: MapPin,
      fill: '#4EE4B3',
      fillOver: '#4EE4B3',
      inshape: 'checkmark',
      stroke: '#000',
    },
  default: {
    PinType: MapPinNormal,
    fill: '#024cbc',
    fillOver: '#052B52',
    stroke: 'none',
  },
  savedPrograms: {
    PinType: MapPinSaved,
    fill: '#024cbc',
    fillOver: '#052B52',
    stroke: 'none',
  },
  savedApplications: {
    PinType: MapPinAdded,
    fill: '#024cbc',
    fillOver: '#052B52',
    stroke: 'none',
  },
  //
  districtSchool: {
    PinType: MapPinNormal,
    fill: '#A2E976',
    fillOver: '#A2E976',
    stroke: '#052B52',
  },
  districtSchoolSaved: {
    PinType: MapPinSaved,
    fill: '#A2E976',
    fillOver: '#A2E976',
    stroke: '#052B52',
  },
  districtSchoolAdded: {
    PinType: MapPinAdded,
    fill: '#A2E976',
    fillOver: '#A2E976',
    stroke: '#052B52',
  },
  //
  earlyEdCenter: {
    PinType: MapPinNormal,
    fill: '#F17373',
    fillOver: '#F17373',
    stroke: '#052B52',
  },
  earlyEdCenterSaved: {
    PinType: MapPinSaved,
    fill: '#F17373',
    fillOver: '#F17373',
    stroke: '#052B52',
  },
  earlyEdCenterAdded: {
    PinType: MapPinAdded,
    fill: '#F17373',
    fillOver: '#F17373',
    stroke: '#052B52',
  },
  //
  charterSchool: {
    PinType: MapPinNormal,
    fill: '#FED844',
    fillOver: '#FED844',
    stroke: '#052B52',
  },
  charterSchoolSaved: {
    PinType: MapPinSaved,
    fill: '#FED844',
    fillOver: '#FED844',
    stroke: '#052B52',
  },
  charterSchoolAdded: {
    PinType: MapPinAdded,
    fill: '#FED844',
    fillOver: '#FED844',
    stroke: '#052B52',
  },
  //
  preKCenter: {
    PinType: MapPinNormal,
    fill: '#F79F56',
    fillOver: '#F79F56',
    stroke: '#052B52',
  },
  preKCenterSaved: {
    PinType: MapPinSaved,
    fill: '#F79F56',
    fillOver: '#F79F56',
    stroke: '#052B52',
  },
  preKCenterAdded: {
    PinType: MapPinAdded,
    fill: '#F79F56',
    fillOver: '#F79F56',
    stroke: '#052B52',
  },
  //
  halfDayOnly: {
    PinType: MapPinNormal,
    fill: '#0C9D6D',
    fillOver: '#0C9D6D',
    stroke: '#052B52',
  },
  halfDayOnlySaved: {
    PinType: MapPinSaved,
    fill: '#0C9D6D',
    fillOver: '#0C9D6D',
    stroke: '#052B52',
  },
  halfDayOnlyAdded: {
    PinType: MapPinAdded,
    fill: '#0C9D6D',
    fillOver: '#0C9D6D',
    stroke: '#052B52',
  },
  //
  earlyLearnThrees: {
    PinType: MapPinNormal,
    fill: '#0C9D6D',
    fillOver: '#0C9D6D',
    stroke: '#052B52',
  },
  earlyLearnSaved: {
    PinType: MapPinSaved,
    fill: '#0C9D6D',
    fillOver: '#0C9D6D',
    stroke: '#052B52',
  },
  earlyLearnAdded: {
    PinType: MapPinAdded,
    fill: '#0C9D6D',
    fillOver: '#0C9D6D',
    stroke: '#052B52',
  },
  // extras
  defaultOver: {
    PinType: MapPinNormal,
    fill: '#052B52',
    fillOver: '#052B52',
    stroke: 'none',
  },
  savedApplicationsOver: {
    PinType: MapPinAdded,
    fill: '#052B52',
    fillOver: '#052B52',
    stroke: 'none',
  },
  savedProgramsOver: {
    PinType: MapPinSaved,
    fill: '#052B52',
    fillOver: '#052B52',
    stroke: 'none',
  },
  familyChildCare: {
    PinType: MapPinNormal,
    fill: '#FED844',
    fillOver: '#FED844',
    stroke: '#052B52',
  },
  preKCenterEligibility: {
    PinType: MapPin,
    fill: '#F17373',
    fillOver: '#F17373',
    stroke: 'none',
    inshape: 'polygon'
  },
  zoneEligibility: {
    PinType: MapPin,
    fill: '#034CBC',
    fillOver: '#034CBC',
    stroke: 'none',
    inshape: 'rect'
  },
  nyceecEligibility: {
    PinType: MapPin,
    fill: '#DF363B',
    fillOver: '#DF363B',
    stroke: 'none',
    inshape: 'ellipse'
  },
  cityWalkEligibility: {
    PinType: MapPin,
    fill: '#ED74CF',
    fillOver: '#ED74CF',
    stroke: 'none',
    inshape: 'triangle'
  },
  charterEligibility: {
    PinType: MapPin,
    fill: '#52575C',
    fillOver: '#52575C',
    stroke: 'none',
    inshape: 'charter'
  },
  halfdayEligibility: {
    PinType: MapPin,
    fill: '#34BF99',
    fillOver: '#34BF99',
    stroke: 'none',
    inshape: 'square'
  },
  familyChildCareEligibility: {
    PinType: MapPin,
    fill: '#FFCC02',
    fillOver: '#FFCC02',
    stroke: 'none',
    inshape: 'familychildcare'
  },
  transferEligibility: {
    PinType: MapPin,
    fill: '#FFFFFF',
    fillOver: '#FFFFFF',
    stroke: '#6d6f6d',
    inshape: 'transfer'
  },
  infantEligibility: {
    PinType: MapPin,
    fill: '#000000',
    fillOver: '#000000',
    stroke: 'none',
    inshape: 'infant'
  },
  specializedEligibility: {
    PinType: MapPin,
    fill: '#9F2982',
    fillOver: '#9F2982',
    stroke: 'none',
    inshape: 'specialized'
  },
  multipleEligibilities: {
    PinType: MapPin,
    fill: 'none',
    fillOver: 'none',
    stroke: 'none',
    inshape: 'multipleEligibilityShape'
  },
  defaultEligibility: {
    PinType: MapPin,
    fill: '#024cbc',
    fillOver: '#052B52',
    stroke: 'none',
    inshape: 'circle'
  },
  d75Eligibility: {
    PinType: MapPin,
    fill: '#ED74CF',
    fillOver: '#ED74CF',
    stroke: 'none',
    inshape: 'd75'
  },
  affiliatedSchools: {
    PinType: MapPin,
    fill: 'green',
    fillOver: 'green',
    stroke: 'none',
    inshape: 'affiliatedSchoolShape'
  }

};

class SchoolPin extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      over: false,
    };
  }

  handleMouseOver = () => {
    this.setState({
      ...this.state,
      over: true,
    });
  };

  handleMouseOut = () => {
    this.setState({
      ...this.state,
      over: false,
    });
  };

  render() {
    const {
      //
      type,
      width,
      height,
      onClick,
      overwriteInnerShapeBy,
    } = this.props;
    const {
      //
      fill,
      stroke,
      PinType,
      fillOver,
      inshape,
    } = pinTypeMap[type] || pinTypeMap.default;
    const { over } = this.state;
    return (
      <div
        //
        onMouseOver={this.handleMouseOver}
        onMouseOut={this.handleMouseOut}
        onFocus={this.handleMouseOver}
        onBlur={this.handleMouseOut}
      >
        <PinType
          //
          width={width}
          height={height}
          onClick={onClick}
          fill={over ? fillOver : fill}
          stroke={stroke}
          inshape={overwriteInnerShapeBy ? overwriteInnerShapeBy : inshape}
        />
      </div>
    );
  }
}

SchoolPin.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  onClick: PropTypes.func,
  type: PropTypes.string,
};

SchoolPin.defaultProps = {
  width: 33,
  height: 40,
  onClick: null,
  type: 'default',
};

export default SchoolPin;
